import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import createComponent from '../../../styles-system/create-component.esm.js';

var Component = createComponent('svg', 'csg');
var Svg = /*#__PURE__*/React.forwardRef(function Svg(props, ref) {
  var size = props.size,
    strokeWidth = props.strokeWidth,
    viewBox = props.viewBox,
    width = props.width,
    height = props.height,
    className = props.className;
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: viewBox,
    width: size ? size + '' : width,
    height: size ? size + '' : height,
    strokeWidth: strokeWidth,
    stroke: strokeWidth ? 'currentcolor' : 'none',
    fill: strokeWidth ? 'none' : 'currentcolor'
  }, props));
});

export default Svg;
//# sourceMappingURL=svg.esm.js.map
